// @flow

// Libs
import { createSelector } from 'reselect'

// Selectors
import currentUser$ from './currentUser'

export default createSelector(
  [
    currentUser$,
  ],
  (currentUser: Object): Array<User> => {
    if (currentUser) {
      return currentUser.units
    }

    return null
  }
)
